import { Space } from 'antd';
import React, { FC, forwardRef } from 'react';
import { FieldOptionBase } from 'api/tasks';
import { byLabel } from 'utils/comparators/by-label';
import { FieldHelper } from 'utils/field';
import { MultiSelectField } from '../fields';
import { EditableProps } from './editable-props';
import { NoValue } from './no-value';
import { SelectFieldOption } from './option';
import { StyledSelect } from './styled-select';

interface Props extends Partial<EditableProps<number[]>> {
  field: MultiSelectField;
}

export const MultiSelectFieldValue: FC<Props> = forwardRef(
  ({ field, editable, onChange }, ref) => {
    const {
      options: { activeOptions, allOptions },
    } = FieldHelper(field);

    return !editable ? (
      (field?.value ?? []).length === 0 ? (
        <NoValue />
      ) : (
        <Space size={2}>
          {allOptions
            .filter((x) => field.value!.includes(x.value))
            .sort(byLabel)
            .map((option) => (
              <SelectFieldOption key={option.value} option={option} />
            ))}
        </Space>
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="tag"
        isMulti
        isClearable
        menuIsOpen
        options={activeOptions}
        value={allOptions.filter((x) => (field.value ?? []).includes(x.value))}
        onChange={(latest: FieldOptionBase[]) =>
          onChange?.((latest ?? []).sort(byLabel).map((x) => x.value))
        }
      />
    );
  },
);
